export default "__VITE_ASSET__C9RigNM8__"